import { Box, styled } from '@mui/material';
import { device } from '../../constants/devices';
import theme from '../../constants/theme';

const InputSearchBoxStyled = styled(Box)({
  '.sui-search-box': {
    justifyContent: 'flex-start',
    flexDirection: 'column',
    marginBottom: '100px',
    position: 'absolute',
    width: '100%',
    bottom: 0,
  },
  '.sui-search-box__wrapper': {
    flexDirection: 'row',
  },
  /* Input */
  '.sui-search-box__text-input': {
    border: `5px solid ${theme.palette.primary.light}`,
    background: 'rgba(51, 51, 51, 0.20)',
    backdropFilter: 'blur(20px)',
    borderRadius: 0,
    fontSize: theme.typography.h6.fontSize,
    color: theme.palette.secondary.main,
    height: '64px',
    fontWeight: 700,
  },
  '.sui-search-box__text-input::placeholder': {
    color: theme.palette.secondary.main,
  },
  /* Autocomplete */
  '.sui-search-box__autocomplete-container': {
    border: `5px solid ${theme.palette.primary.light}`,
    background:
      'linear-gradient(180deg, rgba(8, 69, 36, 0.70) 0%, #0F8345 100%);',
    borderRadius: 0,
    position: 'absolute',
    padding: '20px 16px 0 16px',
    backdropFilter: 'blur(20px)',
    maxHeight: '50px',
    overflow: 'scroll',
    fontSize: theme.typography.h3.fontSize,
    color: theme.palette.secondary.main,
    marginTop: '16px',
  },
  '.sui-search-box__autocomplete-container > div': {
    paddingBottom: '40px',
  },
  '.sui-search-box__autocomplete-container > div:hover, .suggestion:hover': {
    color: theme.palette.secondary.light,
    background: 'none',
    cursor: 'pointer',
  },
  '.btn-search': {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
    padding: '20px',
    textTransform: 'initial',
    minWidth: '180px',
    borderRadius: 'unset',
    height: '64px',
  },
  '.btn-search:hover': {
    backgroundColor: theme.palette.primary.light,
  },
  [device.small]: {
    '.sui-search-box': {
      marginBottom: '30px',
    },
    '.sui-search-box__autocomplete-container': {
      display: 'none',
    },

    '.sui-search-box__text-input': {
      height: '40px',
      padding: '9px',
      fontSize: theme.typography.subtitle2.fontSize,
    },
    '.btn-search': {
      height: '40px',
      padding: 'unset',
      width: '130px',
      minWidth: 'auto',
    },
  },
});

export default InputSearchBoxStyled;
